import React from 'react';

import { Root, Label } from './Chip.styles';
import { Icon, type IconName } from '../Icon';
import { Count, BADGE_COLORS } from '../Tab/Tab.styles';

export type ChipProps = {
  label: string;
  value: string;
  selected: boolean;
  /** An optional count shown as a small badge after the label (same style as the Tab count). */
  count?: number;
  /** Optional mark shown before the label (e.g. a person for the owner's own lists). */
  icon?: IconName;
  /** Receives the chip `value` via `event.currentTarget.dataset.value`. */
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
};

/** Toggleable pill used for the campaign category filters and the game-list chips. */
export const Chip = ({ label, value, selected, count, icon, onClick }: ChipProps): React.ReactElement => (
  <Root type="button" $selected={selected} data-value={value} onClick={onClick}>
    {icon ? <Icon name={icon} size={14} /> : null}
    <Label text={label} tag="span" />
    {count != null ? (
      // Half-transparent background (the number stays opaque), so the count reads lighter than a tab badge.
      <Count $bg={`color-mix(in srgb, ${BADGE_COLORS.subtle.bg} 50%, transparent)`} $fg={BADGE_COLORS.muted.fg}>
        {count}
      </Count>
    ) : null}
  </Root>
);

export default Chip;
